import { css } from '@emotion/css';
import React from 'react';
import bgFriendBalloon from '../../assets/images/bg-friend-balloon.svg';
import { ReactComponent as IconDM } from '../../assets/images/ic_dm.svg';
import { ReactComponent as IconEveryone } from '../../assets/images/ic_everyone.svg';

export const FriendBalloon: React.FC<{ text: string; isDM: boolean }> = ({ text, isDM }) => {
  return (
    <div
      className={css`
        display: flex;
        justify-content: center;
        align-items: center;
        color: #4d3906;
        background-image: url(${bgFriendBalloon});
        background-repeat: no-repeat;
        background-size: 100% 100%;
        min-width: 92px;
        height: 42px;
        padding: 2px 16px 0;
        position: relative;

        .from {
          display: flex;
          align-items: center;
          position: absolute;
          top: -16px;
          left: -8px;
        }
        .row {
          display: flex;
          align-items: center;
          height: 24px;
          border-radius: 14px;
          background: #fb984a;
          color: white;
          font-size: 12px;
          padding: 0 8px 2px ${isDM ? 32 : 40}px;
          position: relative;
        }
        .icon {
          position: absolute;
          top: -${isDM ? 1 : 7}px;
          left: 6px;
        }
      `}
      aria-hidden={true}
    >
      {text}
      <div className="from">
        <div className="row">
          George
          <span className="icon">{isDM ? <IconDM /> : <IconEveryone />}</span>
        </div>
      </div>
    </div>
  );
};
